import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

const BRANDS = [
    {
        index: "01",
        name: "Akash Cargo Movers",
        role: "Containerized Cargo",
        copy: "Full truckload and container movement — 20 ft & 40 ft — from port to warehouse to door.",
    },
    {
        index: "02",
        name: "Anshika Roadlines",
        role: "Heavy Haulage",
        copy: "Heavy machinery, ODC and project cargo moved with permits, escorts and route surveys handled in-house.",
    },
    {
        index: "03",
        name: "Akash Logistics India",
        role: "Freight Forwarding",
        copy: "End-to-end forwarding — documentation, customs coordination and multi-modal routing under one roof.",
    },
];

export default function Brands() {
    return (
        <section id="companies" className="px-5 py-24 md:px-10 md:py-36" data-testid="brands-section">
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="mb-16 md:mb-24"
            >
                <p className="mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-blaze md:text-xs">
                    <span className="inline-block h-2 w-2 bg-blaze" />
                    The Group
                </p>
                <h2 className="max-w-4xl font-display text-4xl uppercase leading-[0.95] tracking-tight md:text-6xl">
                    Three companies. <span className="text-outline-faint">One promise.</span>
                </h2>
            </motion.div>

            <div className="grid border border-white/10 md:grid-cols-3">
                {BRANDS.map((brand, i) => (
                    <motion.a
                        key={brand.name}
                        href="#enquiry"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                        className="group relative flex min-h-[340px] flex-col justify-between border-white/10 p-8 transition-colors duration-300 hover:bg-panel md:min-h-[420px] md:p-10 [&:not(:last-child)]:border-b md:[&:not(:last-child)]:border-b-0 md:[&:not(:last-child)]:border-r"
                        data-testid={`brand-card-${i + 1}`}
                    >
                        <div className="flex items-start justify-between">
                            <span className="font-display text-5xl text-white/15 transition-colors duration-300 group-hover:text-blaze md:text-6xl">
                                {brand.index}
                            </span>
                            <ArrowUpRight
                                size={26}
                                weight="bold"
                                className="text-white/25 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-blaze"
                            />
                        </div>
                        <div>
                            <p className="mb-3 text-[11px] uppercase tracking-[0.3em] text-blaze">{brand.role}</p>
                            <h3 className="mb-4 font-display text-3xl uppercase leading-none tracking-tight md:text-4xl">
                                {brand.name}
                            </h3>
                            <p className="max-w-xs text-sm leading-relaxed text-white/55 md:text-base">{brand.copy}</p>
                        </div>
                        <span className="pointer-events-none absolute bottom-0 left-0 h-0.5 w-0 bg-blaze transition-[width] duration-500 group-hover:w-full" />
                    </motion.a>
                ))}
            </div>
        </section>
    );
}
